module.exports = __webpack_public_path__ + "img/7.a97d271.png";